<template>
	<div class="page_content explore_entity_inside career v_22_1" aria-label="Career Introduction page">
  	<div class="row page-heading">
  		<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading" id="careerIntroTour">
    		<div class="module_icon ico-career"></div>
    		<template v-if="formattedCareer && formattedCareer.name">
    			<career-title class="title_container" :career="formattedCareer"></career-title>
    		</template>
  		</div>
  		<div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
    		<div class="btn_container" v-if="showBackToResultButton">
					<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt">{{deCamelCase()}}</span>
          </b-btn>
          <span v-if="showCalculateRequiredSkillOnResult && isStudentLogin && planningStream" style="font-size: 16px; margin-right: 8px; color: #157099; float: right; cursor: pointer;" :id="'skillProgressPopup_' + formattedCareer.uuid" @click="calculateSkillProgressClicked(formattedCareer, $event)">Calculate Required Skills</span>
				</div>
			</div>
  	</div>

  	<div class="page_content_container pg_content">
  		<career-navigation :active="'introduction'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>

  		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_rgt_panel content_tp_panel">
	  		<div class="row summary_pg program_guide_summary">
	  			<div class="col-12 tp_sec">
	  				<div class="row">
							<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-2">
								<div class="row ml-1 mr-1">
									<div class="col-12 thumbnail_container">
			  						<template v-if="careerOneStopInfo && careerOneStopInfo.videoURL">
											<b-modal class="video_popup" ref="videoModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered size="lg">
												<div class="btn_container">
													<button class="btn_close" @click="closeVideoPopup()" title="close">
														<span class="ic-close"></span>
													</button>
												</div>
												<template v-if="isVideoModalEnable">
													<video width="100%" controls autoplay>
														<source :src="careerOneStopInfo.videoURL" type="video/mp4">
													</video>
												</template>
											</b-modal>

											<div class="play_video" :class="formattedCareer.thumbnailURI ? '' : 'default_thumb_layer'">
												<span class="ic ic8-play2" @click="showVideoPopup()" style="z-index: 1000;"></span>
											</div>
										</template>

										<img :src="formattedCareer.thumbnailURI"
											v-if="formattedCareer.thumbnailURI"
											alt="Career Thumbnail"
											onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';"
											tabindex="0">
										<div v-else class="thumbnail_default ico-career" aria-label="default career image" tabindex="0"></div>
			  					</div>
								</div>

							</div>

							<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-2">
								<div class="row ml-1 mr-1">
									<div class="col-12 other_info career_data">
										<div class="sec_hd row">
											<div class="col-10">
												<h3 class="ace_sec_hd">US Data</h3>
											</div>

											<div class="col-2 data_souce_info" style="margin-right: 0px; margin-top: -4px;">
												<div id="dataSouceInfo" style="float: right;">
													<span class="ic ic8-info5"></span>
												</div>
												<b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
													<div class="popup_content">
														{{careerDataSource}}
													</div>
												</b-popover>
												<div id="dataSouceInfoPopup"></div>
											</div>
										</div>

										<div class="bx_graphics">
											<div class="ic ic22-UsMap"></div>
											<div class="txt">National</div>
										</div>

										<div v-if="showMedianIncome" class="list_info_row ace_sec_txt" :aria-label="'median income ' + currencyLabel + career.medianIncomePerYear">
											<div class="info_title lft_dir">{{medianIncomeLabel}}</div>
											<div class="info_val" v-if="career.medianIncomePerYear">
												{{currencyLabel}} <span v-html="addCommaInNumber(career.medianIncomePerYear)"></span>
											</div>
											<div class="info_no_val" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
											<div class="info_title rgt_dir">{{medianIncomeLabel}}</div>
										</div>

										<div v-if="showJobPostings" class="list_info_row ace_sec_txt" :aria-label="'job postings ' + career.openings">
											<div class="info_title lft_dir">{{jobPostingsLabel}}</div>
											<div class="info_val" v-if="career.openings">
												<span v-html="addCommaInNumber(career.openings)"></span>
											</div>
											<div class="info_no_val align-left" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
											<div class="info_title rgt_dir">{{jobPostingsLabel}}</div>
										</div>

										<div v-if="showGrowthRate" class="list_info_row ace_sec_txt" :aria-label="'growth rate ' + career.growth">
											<div class="info_title lft_dir">{{growthRateLabel}}</div>
											<div class="info_val" v-if="career.growth" :title="career.growth">{{career.growthDoubleFormat.toFixed(1)}}%</div>
											<div class="info_no_val" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
											<div class="info_title rgt_dir">{{growthRateLabel}}</div>
										</div>

										<div class="lnk_container">
											<a href="javascript:void(0);" @click="navigateToCareerProspects">more</a>
										</div>
									</div>
									<!-- Career Goal -->
								</div>
							</div>



              <div class="col-4 other_info career_data target_career" v-if="showSetTargetCareer" :class="careerGoalSelected ? 'active' : ''">
								<div class="sec_ic_container">
									<span class="ic ic22-goal"></span>
								</div>
                <div class="row">
									<div class="col-12 text-center">
										<h6 class="">Your Target Career</h6>
									</div>
								</div>

								<div class="switch_container">
                	<switches v-model="careerGoalSelected" text-enabled="Yes" text-disabled="No"></switches>
								</div>
              </div>
              <!-- Career Goal Ends -->
	  				</div>
	  			</div>
	  		</div>
  		</div>

  		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 recommendations_panel stream_panel" v-if="showRecommendationsTab">
				<div class="row">
					<div class="col-12">

						<div class="sec_hd row">
							<h3 class="col-12 ace_sec_hd" :aria-label="streamRecommendationsLabel">{{streamRecommendationsLabel}}</h3>
						</div>

						<div v-if="isAlumniStreamRecommendationsEnabled" class="row">
							<div class="col-12 stream_type_sec" v-if="alumniStreamRecommendations && alumniStreamRecommendations.length > 0">
								<div class="row">
									<div class="col-12 sub_hd ace_sec_txt" :aria-label="alumniStreamRecommendationsLabel">{{alumniStreamRecommendationsLabel}}</div>
								</div>
								<div class="row">
									<div class="col-12 pg_sec2">
										<div class="content_row">
											<template v-for="stream in alumniStreamRecommendationsToShow">
												<div class="content_block_inner">
													<div class="float-left mr-5 pointer">
														<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'alumniStreamSkillProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.streamId, stream.streamTitle, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
													</div>
													<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.streamTitle" :title="stream.streamTitle" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
														<div class="txt_bx" v-html="setTitleInitials(stream.streamTitle)"></div>
													</div>
													<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
														<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.streamTitle" :title="stream.streamTitle">
															{{stream.streamTitle}}
														</span>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div v-if="isAdvisorStreamRecommendationsEnabled" class="row">
							<div class="col-12 stream_type_sec" v-if="advisorStreamRecommendations && advisorStreamRecommendations.length > 0">
								<div class="row">
									<div class="col-12 sub_hd ace_sec_hd" :aria-label="advisorStreamRecommendationsLabel">{{advisorStreamRecommendationsLabel}}</div>
								</div>
								<div class="row">
									<div class="col-12 pg_sec2">
										<div class="content_row">
											<template v-for="stream in advisorStreamRecommendationsToShow">
												<div class="content_block_inner">
													<div class="float-left mr-5 pointer">
														<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'advisorStreamCreditProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.uuid, stream.title, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
													</div>
													<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.title" :title="stream.title" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
														<div class="txt_bx" v-html="setTitleInitials(stream.title)"></div>
													</div>
													<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
														<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.title" :title="stream.title">
															{{stream.title}}
														</span>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div v-if="isAlumniStreamRecommendationsEnabled || isAdvisorStreamRecommendationsEnabled" class="row">
							<div class="col-12 no_data empty_pattern ace_sec_txt" v-if="(alumniStreamRecommendations && alumniStreamRecommendations.length == 0) && (advisorStreamRecommendations && advisorStreamRecommendations.length == 0)">
								No pathway available
							</div>
						</div>
					</div>
				</div>

				<template v-if="showStreamSkillProgressPopup">
	        <career-stream-skill-progress
	          :title="selectedStreamTitle"
	          :stream-id="selectedStreamUuid"
	          :career-id="career.uuid"
	          :skill-progress-target-id="streamSkillProgressTargetId">
	        </career-stream-skill-progress>
	      </template>

	      <template v-if="showSkillProgressPopup">
	        <explore-career-skill-progress
	          :title="selectedCareer.name"
	          :stream-id="planningStream.uuid"
	          :career-id="selectedCareer.uuid"
	          :skill-progress-target-id="skillProgressTargetId">
	        </explore-career-skill-progress>
	      </template>

			</div>

  		<div class="sec_sep"></div>

  		<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
  			<div class="row pg_sec">
  				<div class="col-12 sec_content">
						<div class="row">
      				<div class="col-12 tbl_sec">
         				<template v-if="formattedCareer && formattedCareer.description">
         					<div class="content-row ace_sec_txt" :aria-label="formattedCareer.description" v-html="formattedCareer.description"></div>
         				</template>
         				<template v-else>
         					<div class="msg_no_data empty_pattern ace_sec_txt" aria-label="No description available for this career">
         						No description available for this career
         					</div>
         				</template>
      			  </div>
	          </div>
		  	  </div>
  			</div>
  		</div>

  	</div>

	</div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import CareerTitle from './CareerTitle'
  import CareerNavigation from './CareerNavigation'
  import CareerStreamSkillProgress from './CareerStreamSkillProgress'
  import ExploreCareerSkillProgress from '../../explore/components/ExploreCareerSkillProgress'
  import { StorageFactory } from '../../../storageFactory'
	export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'career-intro',
    props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
    components: {
    	CareerTitle,
      CareerNavigation,
      CareerStreamSkillProgress,
      ExploreCareerSkillProgress
    },
    data: () => {
      return {
        RECOMMENDATION_TERM_LIMIT: 3,
        DEFAULT_RETURN_TO: 'exploreCareerResults',
        EXPLORE_RESULTS: 'exploreCareerResults',
        isVideoModalEnable: false,
        selectedStreamUuid: null,
        selectedStreamTitle: null,
        streamSkillProgressTargetId: '',
        showStreamSkillProgressPopup: false,
        selectedCareer: null,
        skillProgressTargetId: '',
        showSkillProgressPopup: false,
        userObject: JSON.parse(localStore.getItem('userobj')),
        careerGoalSelected: false,
        isRevertAction: false
      }
    },

    mounted () {
    	this.loadDataForCareerDetail()
    },

    beforeRouteLeave (to, from, next) {
      // If the form is dirty and the user did not confirm leave,
      // prevent losing unsaved changes by canceling navigation
      let tempUser = localStorage.getItem('tempUser')
      if (tempUser && tempUser === 'true') {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Cannot move past this page till account setup is complete'
        })
        this.showNewFormPopup()
        this.nextPage = next
      } else {
        // Navigate to next view
        next()
      }
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'loadCareerOneStopInfo',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations',
        'loadLogDashboardActivity',
        'loadSaveProfileCareer'
      ]),
      addCommaInNumber (numValue) {
        if (!numValue) {
          return numValue
        }
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
			goToStreamPage (stream) {
        let uuid = (stream.streamId) ? stream.streamId : stream.uuid
        return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
      },
      async loadDataForCareerDetail () {
        let career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
        await this.loadCareerOneStopInfo(career.code)
        let alumniRecommendationData = this.buildAlumniStreamRecommendationData(career)
        let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(career)
        await this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
        await this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
        if (this.userObject && this.userObject.careerGoal && this.userObject.careerGoalPragyaSoc && this.userObject.careerGoalPragyaSoc === this.code) {
          this.careerGoalSelected = true
          this.isRevertAction = true
        }
        this.loadLogDashboardActivity({action: 'viewCareerIntroduction', page: 'careerIntro', link: '', careerSocCode: this.code})
      },
      returnToClicked () {
      	if (this.returnTo === 'relatedCareers') {
	        let routerParams = JSON.parse(localStore.getItem('returnCareerIntroParams'))
	        localStore.removeItem('returnCareerIntroParams')
	        return this.$router.push({name: this.returnTo, params: routerParams, query: {returnTo: routerParams.returnTo}})
	      }
      	return this.$router.push({name: this.returnTo})
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to career results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      parseTerms (sourceList) {
        if (!sourceList || !sourceList.length) {
          return []
        }
        let targetList = []
        let TERM_LIMIT = this.RECOMMENDATION_TERM_LIMIT
        sourceList.forEach((item, i) => {
          if (i < TERM_LIMIT) {
            let curr = JSON.parse(item)
            targetList.push(curr.name)
          }
        })
        return targetList
      },
      buildAlumniStreamRecommendationData (career) {
        let data = {
          'title': career.name,
          'socCode': career.code,
          'topCompanies': this.parseTerms(career.topPostingCompanies),
          'topSkills': this.parseTerms(career.skills),
          'majors': career.majors || [],
          'departments': career.departments || [],
          'category': career.category || ''
        }
        return data
      },
      buildAdvisorStreamRecommendationData (career) {
        let data = {
          'requestType': 'career',
          'relatedCipCodes': career.cipCodes
        }
        return data
      },
      setTitleInitials (entityTitle) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      },
      calculateStreamSkillProgressClicked (uuid, title, event) {
        this.selectedStreamUuid = uuid
        this.selectedStreamTitle = title
        this.streamSkillProgressTargetId = event.target.id
        this.showStreamSkillProgressPopup = true
      },
      calculateSkillProgressClicked (career, event) {
        this.selectedCareer = career
        this.skillProgressTargetId = event.target.id
        this.showSkillProgressPopup = true
      },
      showVideoPopup () {
				this.$refs.videoModal.show()
        this.isVideoModalEnable = true
      },
      closeVideoPopup () {
        this.$refs.videoModal.hide()
				this.isVideoModalEnable = false
      },
      navigateToCareerProspects () {
      	let routerParams = {
	        code: this.code || this.career.pragyaSoc,
	        cipCode: this.cipCode,
	        returnTo: this.EXPLORE_RESULTS,
	        showBackToResultButton: true
	      }
	      return this.$router.push({name: 'careerDetailProspects', params: routerParams, query: {returnTo: 'exploreCareerResults'}})
	    },
      async updateCareerGoalSelected() {
        if (this.careerGoalSelected) {
          this.$swal({
            title: 'Set Target Career',
            text: 'Are you sure you would like to set ' + this.career.name + ' as your target career? The recommendations will be tailored to this choose. Of course you can always change it again.',
            showDenyButton: true,
            confirmButtonText: 'Yes! Set my target career',
            denyButtonText: `Don't set my target career`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

              // Call update profile api
              this.loadSaveProfileCareer({careerGoal: this.career.name , careerGoalPragyaSoc: this.code})
              this.$swal('Saved!', '', 'success')
            } else if (result.isDenied) {
              this.careerGoalSelected = !this.careerGoalSelected
              this.isRevertAction = true
              this.$swal('Changes are not saved', '', 'info')
            }
          })
        } else {
          this.$swal({
            title: 'Remove Target Career',
            text: 'Are you sure you would like to remove ' + this.career.name + ' as your target career?',
            showDenyButton: true,
            confirmButtonText: 'Yes! Remove target career',
            denyButtonText: `Don't remove my target career`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

              // Call update profile api
              this.loadSaveProfileCareer({careerGoal: '', careerGoalPragyaSoc: ''})
              this.$swal('Saved!', '', 'success')
            } else if (result.isDenied) {
              this.careerGoalSelected = !this.careerGoalSelected
              this.isRevertAction = true
              this.$swal('Changes are not saved', '', 'info')
            }
          })
        }
      }
    },
    watch: {
      careerGoalSelected (newCareerGoalSelected) {
        if (!this.isRevertAction) {
          this.updateCareerGoalSelected()
        } else {
          this.isRevertAction = false
        }
      }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject,
        'careerResult': state => state.career.careerResultObject,
        'careerOneStopData': state => state.career.careerOneStopInfo,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'packages': state => state.institution.packages,
        'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
        'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
        'planningStream': state => state.dashboard.planningStream
      }),
      isCurrentCareerGoal () {
        if (this.userObject && this.userObject.careerGoal && this.userObject.careerGoalPragyaSoc && this.userObject.careerGoalPragyaSoc === this.code) {
          return true
        }
        return false
      },
      careerDataSource () {
        if (this.isBGTFeatureEnabled) {
          return 'Source: Burning Glass. 2018-2028'
        }
        if (this.isLightcastFeatureEnabled) {
          return 'Source: Lightcast. 2023-2033'
        }
        return 'Source: BLS. 2016-2026'
      },
      showMedianIncome () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.enabled
      },
      medianIncomeLabel () {
        const defaultLabel = 'median income'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.label || defaultLabel
      },
      showJobPostings () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.enabled
      },
      jobPostingsLabel () {
        const defaultLabel = 'job postings'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.label || defaultLabel
      },
      showGrowthRate () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.enabled
      },
      growthRateLabel () {
        const defaultLabel = 'growth rate'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.label || defaultLabel
      },
      careerOneStopInfo () {
        let careerOneStopData = this.careerOneStopData
        if (!careerOneStopData || !careerOneStopData.uuid) {
          return {}
        }
        return careerOneStopData
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        return bgtFeature && bgtFeature.enabled
      },
      isLightcastFeatureEnabled () {
        let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
        return lightcastFeature && lightcastFeature.enabled
      },
      exploreCareerDetailFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      isAlumniStreamRecommendationsEnabled () {
        return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
      },
      isAdvisorStreamRecommendationsEnabled () {
        return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
      },
      streamRecommendationsLabel () {
        const defaultLabel = 'Pathways'
        let streamRecommendationsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID]
        if (!streamRecommendationsFeature || !streamRecommendationsFeature.label) {
          return defaultLabel
        }
        return streamRecommendationsFeature.label || defaultLabel
      },
      recommendationFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
        let coursePlanningPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      advisorStreamRecommendationsToShow () {
        return this.advisorStreamRecommendations.splice(0, 1)
      },
      advisorStreamRecommendationsLabel () {
        const defaultLabel = 'Advisor Streams'
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showAdvisorStreamRecommendations) {
          return defaultLabel
        }
        return recommendationFlagMap.showAdvisorStreamRecommendations.label || defaultLabel
      },
      alumniStreamRecommendationsToShow () {
        return this.alumniStreamRecommendations.splice(0, 1)
      },
      alumniStreamRecommendationsLabel () {
        const defaultLabel = 'Alumni Streams'
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showAlumniStreamRecommendations) {
          return defaultLabel
        }
        return recommendationFlagMap.showAlumniStreamRecommendations.label || defaultLabel
      },
      getThumbnailURI () {
	      return 'https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/soc-' + this.code + '---00.svg'
	    },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.name) ? this.careerResult : this.career
        if (!formattedCareer) {
          return {}
        }
        if (!this.career.thumbnailURI) {
        	this.career.thumbnailURI = this.getThumbnailURI
        }
        formattedCareer.thumbnailURI = this.career.thumbnailURI
        return formattedCareer
      },
      showRecommendationsTab () {
        return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
      },
      isRecommendationFeatureEnabled () {
        let recommendationsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID]
        if (recommendationsFeature) {
          return recommendationsFeature.enabled
        }
        return false
      },
      currencyLabel () {
        return '$'
      },
      isCareerSkillProgressEnabled () {
        let path = this.$router.currentRoute.fullPath
        let isPathwaysTab = (path.indexOf('streams') !== -1)
        if (isPathwaysTab) {
          return false
        }
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showCareerSkillProgress) {
          return false
        }
        return recommendationFlagMap.showCareerSkillProgress.enabled
      },
      exploreCareersFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREERS
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      showCalculateRequiredSkillOnResult () {
        let exploreCareersFlagMap = this.exploreCareersFlagMap
        if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultCalculateRequiredSkill) {
          return false
        }
        return exploreCareersFlagMap.searchResultCalculateRequiredSkill.enabled
      },
      showSetTargetCareer () {
        let exploreCareersFlagMap = this.exploreCareersFlagMap
        if (!exploreCareersFlagMap || !exploreCareersFlagMap.setTargetCareer) {
          return false
        }
        return exploreCareersFlagMap.setTargetCareer.enabled
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      }
    }
  }
</script>

<style scoped>
  .pointer {
     cursor: pointer;
  }
	.title_container {
		width: calc(100% - 50px);
	}
	.page-heading .module_heading .head_txt {
		max-width: calc(100% - 20px);
	}
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerIntro.vue